<template>
  <div v-if="screenHeight>700">
  <p v-show="setNumber == 0 && screenWidth>600" class="user"> Beantworte die {{ myQuestions.questions.length }} Fragen um herauszufinden ob du in unser Team passt.<br> Gebe die Nummern der Antwortmöglichkeiten in das Eingabefeld ein.</p>
  <p v-show="setNumber == 0 && screenWidth<=600" class="user"> Beantworte die {{ myQuestions.questions.length }} Fragen um herauszufinden ob du in unser Team passt.<br> Tippe deine Antwort an und bestätige mit "Weiter"</p>
  <p v-show="setNumber > 0" class="user">{{ returnCurrentQuestion() }}  </p>
  </div>
  <p class="user">{{ printQuestion() }}</p>
</template>


<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  screenHeight: Number,
  screenWidth: Number,
  myQuestions: null,
  setNumber: Number,
})


//function log(){
//  console.log(props.myQuestions.name);
//}
function printQuestion() {
      //let ques = this.myQuestions();
      let setNumber = props.setNumber;
      let answerOptions = props.myQuestions.questions[setNumber].question;
      return answerOptions;
}

function returnCurrentQuestion(){
      let setNumber = props.setNumber;
      let quesLength = props.myQuestions.questions.length;
      return setNumber + " von " + quesLength + " Fragen beantwortet";
}


</script>


<style scoped>

</style>